import React from 'react';
import DevActions from 'components/Util/DevActions/DevActions';
import AuthDebug from 'components/Auth/AuthDebug/AuthDebug';
import DebugToolsObjectView from 'components/Util/DebugTools/DebugToolsObjectView';

import './dev-footer-tools.css';

const DevFooterTools = () => {
    return (
        <div className="dev-footer-tools">
            <DevActions />
            <AuthDebug />
            <DebugToolsObjectView />
        </div>
    );
};

export default DevFooterTools;
